interface TruncateProps {
  text: string;
  maxLength: number;
  truncateEnding: string;
}

const Truncate: React.FC<TruncateProps> = ({ text, maxLength, truncateEnding }) => {
  // Truncate email if it exceeds maxLength
  const truncatedEmail: string = text.length > maxLength ? `${text.substring(0, maxLength)}${truncateEnding}` : text;

  return (
    <div className="email">
      <span>{truncatedEmail}</span>
    </div>
  );
};

export default Truncate;
